import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import { Grid, Typography, Paper, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import { DataGrid } from '@mui/x-data-grid';
import { format } from 'date-fns';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        minWidth: 350,
        overFlowX: "auto",
    },
    formControl: {
        minWidth: "100%",
    },
    sectionTitle: {
        fontSize: 19,
        color: "#174a84",
        marginBottom: 16,
    },
    checkboxDividerLabel: {
        marginTop: 10,
        marginLeft: 5,
        marginRight: 20,
        fontSize: 16,
        fontWeight: 600,
    },
    rootProgress: {
        width: "100%",
        textAlign: "center",
    },
}));

const Calendar = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoginMenu, setIsLoginMenu] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [TimeTableDataArray, setTimeTableDataArray] = useState([]);

    const handleOpenSnackbar = (msg, severity) => {
        setIsOpenSnackbar(true);
        setSnackbarMessage(msg);
        setSnackbarSeverity(severity);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setIsOpenSnackbar(false);
    };

    const loadTimeTableData = async () => {
        setIsLoading(true);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C101CommonAcademicsTimeTableView`;
        await fetch(url, {
                method: "POST",
                headers: new Headers({
                        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
                }),
        })
        .then((res) => {
                if (!res.ok) {
                        throw res;
                }
                return res.json();
        })
        .then(
                (json) => {
                        if (json.CODE === 1) {
                                setTimeTableDataArray(json.DATA || []);
                        } else {
                                handleOpenSnackbar(
                                        json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
                                        "error"
                                );
                        }
                        console.log("TimeTableDataArray", json);
                },
                (error) => {
                        if (error.status === 401) {
                                setIsLoginMenu(true);
                                setIsReload(true);
                        } else {
                                console.log(error);
                                handleOpenSnackbar(
                                        "Failed to fetch ! Please try Again later.",
                                        "error"
                                );
                        }
                }
        );
        setIsLoading(false);
    };

    useEffect(() => {
      loadTimeTableData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        { field: 'title', headerName: 'Title', width: 250 },
        {
            field: 'startDate',
            headerName: 'Start Date',
            width: 180,
            valueFormatter: (value) => {
                if (!value) return '';
                try {
                    // Check if value is a timestamp (number)
                    const timestamp = typeof value === 'number' ? value : parseInt(value);
                    if (!isNaN(timestamp)) {
                        return format(new Date(timestamp), 'MMM dd, yyyy hh:mm a');
                    }
                    return value;
                } catch {
                    return value;
                }
            }
        },
        {
            field: 'endDate',
            headerName: 'End Date',
            width: 180,
            valueFormatter: (value) => {
                if (!value) return '';
                try {
                    // Check if value is a timestamp (number)
                    const timestamp = typeof value === 'number' ? value : parseInt(value);
                    if (!isNaN(timestamp)) {
                        return format(new Date(timestamp), 'MMM dd, yyyy hh:mm a');
                    }
                    return value;
                } catch {
                    return value;
                }
            }
        },
        { field: 'allDay', headerName: 'All Day', width: 100, type: 'boolean' },
    ];

    const rows = TimeTableDataArray.map((item, index) => ({
        id: item.id || index,
        title: item.title || '',
        startDate: item.startDate || '',
        endDate: item.endDate || '',
        allDay: item.allDay || false,
        ...item
    }));

    return (
        <Fragment>
                <LoginMenu
                        reload={isReload}
                        open={isLoginMenu}
                        handleClose={() => setIsLoginMenu(false)}
                />
                <Grid container component="main" className={classes.root}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: 16 }}>
                            <IconButton
                                onClick={() => navigate('/dashboard')}
                                style={{ marginRight: 10, color: "#174a84" }}
                                size="large"
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography variant="h5" className={classes.sectionTitle} style={{ marginBottom: 0, flex: 1 }}>
                                Class Schedule
                            </Typography>
                        </div>
                        <Paper style={{ height: 600, width: '100%' }}>
                                <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        loading={isLoading}
                                        pageSizeOptions={[10, 25, 50]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { pageSize: 25, page: 0 },
                                            },
                                        }}
                                />
                        </Paper>
                </Grid>
                <CustomizedSnackbar
                        isOpen={isOpenSnackbar}
                        message={snackbarMessage}
                        severity={snackbarSeverity}
                        handleCloseSnackbar={() => handleCloseSnackbar()}
                />
        </Fragment>
    );
};

export default Calendar;
